import { Link } from "react-router-dom";
import { roleNames } from "../../constant";

const Navlink = ({ item, pathname, role, handleLogout }) => {
  const isActive =
    pathname === item?.adminPath ||
    pathname === item?.qaPath ||
    (item?.additionalPaths && item?.additionalPaths.some((path) => pathname.includes(path)));
  const isLogout = item?.title?.toLowerCase() === "log out";

  if (isLogout) {
    return (
      <button
        style={{ border: "none", background: "none" }}
        className={`nav-link ${isActive ? "active" : ""}`}
        onClick={handleLogout}
      >
        <i className={`${item?.icon} icon`}></i>
        <span className="mx-2">{item?.title}</span>
      </button>
    );
  } else {
    return (
      <Link
        to={role === roleNames.superAdmin ? item?.adminPath : item?.qaPath}
        className={`nav-link ${isActive ? "active" : ""}`}
        data-bs-dismiss="offcanvas"
      >
        <i className={`${item?.icon} icon`}></i>
        <span>{item?.title}</span>
      </Link>
    );
  }
};

export default Navlink;
